<template>

  <div id="academy">

    <div class="c-img-bg c-academy-bg">

      <div class="container-xl">
        <div class="row">
          <div class="col-12">

            <!-- navigation-->
            <Navi dark-mode></Navi>

            <!-- academy -->  
            <div class="row justify-content-center">
              <div class="col-11 coll-md-10">                    
                <div class="row">
                  <div class="col-12 d-flex align-items-center flex-column">
                    <h1 class="c-h1">Happiness & Work Academy</h1>  
                    <p class="c-txt-orange" style="font-weight: bold;">Profitiere von unserem Know-How</p>      
                  </div>
                  <div class="col-12 py-3 col-md-8 d-flex align-items-center justify-content-center">             
                    <p class="text-center text-md-left">
                        Lerne wie Glück funktioniert! Das geht leicht, denn wir haben verschiedene Formate entwickelt. 
                        Eines haben aber alle gemeinsam: Sie bringen Dir für Deine persönliche Situation nahe, 
                        wie der aktuelle Stand der Forschung ist und lassen Platz für Austausch. 
                        Buzzwordbingo und Fachchinesisch haben wir einfach gestrichen und durch jede Menge Spaß ersetzt. 
                        Gespannt auf uns? Wir auch! - auf Dich!  
                    </p>             
                    <img id="bubble_academy_1" src="@/assets/bubble_red_1.png" alt="bubble">  
                  </div>

                  <!-- button -->
                  <div class="col-12 d-flex justify-content-left">
                    <a :href="`mailto:office@felicicon.com?subject=${emailSubject}&body=${emailBody}`">
                      <div class="c-btn c-btn-orange" >
                        <span style="padding: 10px">Jetzt buchen</span>
                        <div class="c-btn-img c-btn-img-right-white"/>
                      </div>
                    </a>
                  </div>
                </div>    
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- wave bottom -->
      <div class="c-wave c-wave-bottom"/>
    </div>

    <!-- academy overview -->
    <div class="container-xl">
      <!-- 1-3 -->
      <div class="row justify-content-center">
        <div class="col-11 col-md-10 pb-5">   
          <div class="row align-items-end">
            <!-- workshops & trainings -->
            <div class="col-12 order-1 col-md-4 order-md-4">
              <img src="@/assets/academy_workshops-sm.png" alt="Academy_workshops_and_trainings" style="margin: 20px; width: 85%; max-width: 280px;">
            </div>
            <div class="col-12 order-2 col-md-4 order-md-1">
              <h2 class="c-h2 c-txt-yellow">Workshops & Trainings</h2>
            </div>
            <div class="col-12 order-3 col-md-4 order-md-7 align-self-start text-left">
              <p>
                Wir bieten Workshops & Seminare zu den wichtigsten Bereichen von Glück bei der Arbeit an, die sich an Mitarbeitende und Führungskräfte richten.
                Unsere Seminare verbinden Teams und zeigen welche Intervention im Arbeitsalltag den meisten Effekt haben wird. 
              </p>
            </div> 
            <div class="col-12 order-4 col-md-4 order-md-10">
              <div class="d-flex justify-content-center">  
                <!-- button -->
                <router-link to="/academy/workshops_and_seminars" style="text-decoration: none">
                  <div class="c-btn c-btn-orange" >
                    <span style="padding: 5px">Mehr Infos</span>
                    <div class="c-btn-img c-btn-img-right-white"/>
                  </div>
                </router-link>
              </div>
            </div>
            <!-- happiness hacks -->
            <div class="col-12 order-5 col-md-4 order-md-5">
              <img src="@/assets/academy_hacks-sm.png" alt="Academy_Happiness_Hacks" style="margin: 20px; width: 95%;  max-width: 280px;">
            </div>  
            <div class="col-12 order-6 col-md-4 order-md-2">
              <h2 class="c-h2 c-txt-blue">Happiness Hacks</h2>
            </div>
            <div class="col-12 order-7 col-md-4 order-md-8 align-self-start text-left">
              <p>
                Positive Psychologie ist in aller Munde. Aber wie kann jeder Mitarbeitende sie im Arbeitsalltag für sich praktisch nutzen? 
                Dazu geben unsere Happiness Hacks Auskunft - 9 mal 45 Minuten Wissen und Tools als interaktive Online-Session, die das ganze Unternehmen sofort nutzen kann.
              </p>
            </div>
            <div class="col-12 order-8 col-md-4 order-md-11">
              <div class="d-flex justify-content-center">  
                <!-- button -->
                <router-link to="/academy/happiness_hacks" style="text-decoration: none">
                  <div class="c-btn c-btn-orange">
                    <span style="padding: 5px">Mehr Infos</span>
                    <div class="c-btn-img c-btn-img-right-white"/>
                  </div>
                </router-link>
              </div>
            </div>            
            <!-- knowledge & tools -->
            <div class="col-12 order-9 col-md-4 order-md-6">
              <img src="@/assets/academy_tools-sm.png" alt="HappinessAndWork_Positive_Leadership" style="margin: 20px; width: 90%; max-width: 280px;">
            </div>
            <div class="col-12 order-10 col-md-4 order-md-3">
              <h2 class="c-h2 c-txt-orange">Wissen & Tools</h2>
            </div>            
            <div class="col-12 order-11 col-md-4 order-md-9 align-self-start text-left">
              <p>
                Hier wächst eine Zauberkiste voller Tipps, Tricks, Interventionen. Für Führungskräfte, für Coaches, für Trainer und Mitarbeitende. 
                Wir suchen für euch die besten und wirksamsten Interventionen der Positiven Psychologie zusammen und schreiben eine Anleitung dazu. Stöbere gerne mal!
              </p>
            </div>
            <div class="col-12 order-12 col-md-4 order-md-12">
              <div class="d-flex justify-content-center">  
                <!-- button -->
                <router-link to="/academy/knowledge_and_tools" style="text-decoration: none">
                  <div class="c-btn c-btn-orange" >
                    <span style="padding: 5px">Mehr Infos</span>
                    <div class="c-btn-img c-btn-img-right-white"/>
                  </div>
                </router-link>
              </div>
            </div>  
          </div>
        </div>
      </div>
    </div>

    <!-- footer -->
    <div class="c-orange-bg">   
      <!-- wave top -->
      <div class="c-wave c-wave-top" style="position: relative; top:-2px;"/>
      <!-- footer content -->
      <div class="container-xl">
        <div class="row c-txt-white c-footer">
          <div class="col-12">
            <Footer></Footer>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Navi from '@/components/Navi.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Academy',
  components: {
    Navi,
    Footer
  },
  metaInfo() {
    // patch meta data on current page
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: `${this.metaTitle}`,
      meta: [
        { vmid: "keywords",  name: 'keywords', content: `${this.metaKeywords}` },
        { vmid: "description", name: 'description', content: `${this.metaDescription}`},
        // social tagging
        { vmid: "og:title", property: "og:title", content: `${this.metaTitle}` },
        { vmid: "og:url", property: "og:url", content: `${this.metaUrl}` },
        { vmid: "og:description", property: "og:description", content: `${this.metaDescription}` },
        { vmid: "og:image", name: 'og:image', content: `${this.metaImage}` }
      ]
    }
  },
  data() {
    return {
      // email data
      emailSubject: "HAW Anfrage - Academy - Happiness %26 Work Academy",
      emailBody: "Guten Tag,%0A%0Aich bin auf der Website www.happinessandwork.de auf euer Angebot aufmerksam geworden.%0AIch interessiere mich insbesondere für die 'Happiness %26 Work Academy'.%0AIch würde gern diesbezüglich kontaktiert werden - Tel: [meine_telefonnummer]%0A%0AVielen Dank",

      // metaData
      metaTitle: "- Academy - Wie schafft es eine Organisation, dass ihre Mitarbeiter glücklich sind?",
      metaDescription: "Wie schafft es eine Organisation, dass ihre Mitarbeiter glücklich sind? Die Felicicon GmbH hat Weiterbildungsangebote für Mitarbeiter und Führungskräfte und führen in Mitarbeiter Events in das Thema ein.",
      metaUrl: "/academy",
      metaKeywords: "Seminar Beratung Coaching Teamentwicklung Keynotes 'Happinessandwork Academy'",
      metaImage: "https://www.happinessandwork.de/share/academy.png"
    }
  },
  // called when component is mounted to the dom
  mounted: function () {
    // Create render evnt puppeteer is waiting for when prerender pager (see param: renderAfterDocumentEvent)
    document.dispatchEvent(new Event('render-event'))
  },
  methods: {
  }
}

</script>

<style>
</style>
